export default {
    isSelected: true,
    boxes: [
        // Product Selector
        {
            heading: "precision-ball-splines-header",
            text: "precision-ball-splines-desc",
            image: "Assembly.png",
            apiName: "Precision",
            toolType: "Selector",
            isSelected: false,
            alertText: "new-products",
        },

        // Product Selector
        {
            heading: "heavy-duty-ball-splines-header",
            text: "heavy-duty-ball-splines-desc",
            image: "Heavy-Duty.png",
            apiName: "HeavyDuty",
            hiddenElementId: "legacy-ball-spline-selector-container",
            isSelected: false
        },

        // Contact Thomson
        {
            heading: "contact-thomson-heading",
            text: "",
            image: "Contact_Thomson.png",
            apiName: "ContactThomson",
            toolType: "ContactThomson",
            redirectUrl: "path.tlo.contact-us",
            hideForDistributor: true,
            isSelected: false
        },
    ]
}